export const breakpoints = {
	// mobile: 0, // px
	// mobileWide: 360, // px
	tablet: 700, // px
	tabletWide: 1000, // px
	desktop: 1280, // px
	desktopWide: 1600, // px
};
